/* ============================================================
   Brockett Built — predictive-search.js
   Predictive search via Shopify's /search/suggest.json endpoint
   ============================================================ */

(function () {
  'use strict';

  const input = document.querySelector('[data-predictive-input]');
  const results = document.querySelector('[data-predictive-results]');
  if (!input || !results) return;

  let debounce;
  let abort;

  input.addEventListener('input', () => {
    clearTimeout(debounce);
    debounce = setTimeout(() => query(input.value.trim()), 200);
  });

  async function query(q) {
    if (!q) {
      results.innerHTML = '<h5>Type to search</h5><p style="color:var(--ink-3);font-size:13px;">Search by part name, vehicle, or finish.</p>';
      return;
    }

    if (abort) abort.abort();
    abort = new AbortController();

    try {
      const url = `${window.theme.routes.predictive_search_url}.json?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=6`;
      const res = await fetch(url, { signal: abort.signal });
      const data = await res.json();
      render(data.resources.results.products || []);
    } catch (e) {
      if (e.name !== 'AbortError') console.error('search failed', e);
    }
  }

  function render(products) {
    if (products.length === 0) {
      results.innerHTML = '<h5>No matches</h5><p style="color:var(--ink-3);font-size:13px;">Try a different search.</p>';
      return;
    }
    results.innerHTML = `<h5>Products (${products.length})</h5>` + products.map(p => {
      const img = p.image ? p.image.replace(/(\.[a-z]+)(\?.*)?$/i, '_120x$1$2') : '';
      return `
        <a href="${p.url}" class="search-result-card">
          ${img ? `<img src="${img}" width="56" height="56" alt="">` : '<div style="width:56px;height:56px;background:var(--bg-sunken);"></div>'}
          <div>
            <div class="name">${escapeHTML(p.title.replace('Brockett Built ', ''))}</div>
            <div style="font-size:11px;color:var(--ink-3);text-transform:uppercase;letter-spacing:.18em;margin-top:2px;">${escapeHTML(p.vendor || p.type || '')}</div>
          </div>
          <div class="price">${formatPrice(p.price)}</div>
        </a>`;
    }).join('');
  }

  function formatPrice(p) {
    if (typeof p === 'string') return p;
    return window.formatMoney ? window.formatMoney(p) : `$${(p/100).toFixed(2)}`;
  }
  function escapeHTML(s) {
    return String(s || '').replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  }
})();
